import axios from "axios";
import { apiDomain } from "../../config";

export default {
  getLocationsIndicatorsData() {
    return new Promise((resolve, reject) => {
      axios
        .get(apiDomain + "/locations_indicator/", {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("access_token")
          }
        })
        .then(response => {
          var data = "";
          if (response.data.status === "success") {
            data = response.data;
            resolve(data);
          } else {
            data = response.data;
            resolve(data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  send_volumeChange(filter_by) {
    return new Promise((resolve, reject) => {
      axios
        .post(apiDomain + "/location_volume_change/", filter_by, {
          headers: {
            "Content-Type": "application/json",
            token: localStorage.getItem("access_token")
          }
        })
        .then(response => {
          var data = "";
          if (response.data.status === "success") {
            data = response.data;
            resolve(data);
          } else {
            data = response.data;
            resolve(data);
          }
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  getChartConfig() {
    return {
      chart: {
        type: "scatter",
        inverted: true,
        marginLeft: 0,
        height: 55
      },
      title: {
        text: null
      },
      legend: {
        enabled: false
      },
      yAxis: {
        gridLineWidth: 0
      },
      xAxis: {
        categories: []
      },
      plotOptions: {
        series: {
          stickyTracking: true,
          pointPadding: 0.25,
          borderWidth: 0,
          color: "#000",
          marker: {
            symbol: "target",
            height: 10,
            width: 10,
            lineWidth: 4
          }
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        outside: true,
        useHTML: true,
        //headerFormat: null,
        //pointFormat: "{series.name}: <b>{point.y}m<sup>3</sup></b>"
      }
    };
  },
  getChartConfig_1() {
    return {

      title: {
        text: null
      },
      legend: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        borderWidth: 0
      },
      plotOptions: {
        spline: {
          lineWidth: 2,
          marker: {
              enabled: false
          },
        }
      },
      credits: {
        enabled: false
      },
      exporting: {
        enabled: false
      },
      tooltip: {
        outside: true,
      }
    };
  }
};



// WEBPACK FOOTER //
// ./src/views/intraday/intraday_service.js